var _path, _circle, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPostItemPlaceholderDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 579,
    height: 220,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h579v220H0z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 42,
    r: 22,
    fill: "#F3F4F8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 24,
    width: 140,
    height: 14,
    rx: 2,
    fill: "#F3F4F8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 98,
    width: 245,
    height: 14,
    rx: 2,
    fill: "#F3F4F8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 132,
    width: 481,
    height: 14,
    rx: 2,
    fill: "#F3F4F8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 154,
    width: 524,
    height: 14,
    rx: 2,
    fill: "#F3F4F8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 176,
    width: 355,
    height: 14,
    rx: 2,
    fill: "#F3F4F8"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 47,
    width: 60,
    height: 14,
    rx: 2,
    fill: "#F3F4F8"
  })));
}
export default SvgPostItemPlaceholderDesktop;